<div class="login-page" *ngIf="ready">


  <div class="row">
    <div class="col-12">
      <div class="header">
        <div class="main_header">
          <img class="logo-imgs" src="assets/svg/BA Logo with Tagline Standard.svg" alt="Blue Pulse" />
        </div>
      </div>
    </div>
  </div>

  <div class="row login-bg">

    <div class="col-lg-6 col-md-12 login-left-content">
      <label class="login-title">
        Built for Modern Workforce Management
      </label>
      <p class="login-subtitle">
        Get visibility into working hours, evaluate performance, and gain actionable insights to improve productivity.
      </p>
    </div>

    <div class="col-lg-6 col-md-12 d-flex justify-content-center">

      <mat-card class="admin_login_matcard">

        <label class="title">
          {{ firstTimeLogged ? 'Set Password' : 'Reset Password' }}
        </label>

        <div class="expired" *ngIf="timerExpired">
          Reset link has expired. Please request again.
        </div>

        <form [formGroup]="passwordForm" (ngSubmit)="submit()" *ngIf="!timerExpired" novalidate>

          <mat-form-field appearance="outline" class="full-width input-field">
            <mat-label>New Password</mat-label>
            <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password" autocomplete="off" />
            <button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword"
              class="password-toggle">
              <mat-icon>
                {{ hidePassword ? 'visibility_off' : 'visibility' }}
              </mat-icon>
            </button>

            <mat-error *ngIf="passwordForm.get('password')?.hasError('required')">
              Password is required
            </mat-error>
            <mat-error *ngIf="passwordForm.get('password')?.hasError('passwordStrength') &&
    passwordForm.get('password')?.touched &&
    passwordForm.get('password')?.value" class="spaceTop">
              Password does not meet criteria
            </mat-error>
          </mat-form-field>

          <div class="password-checklist" *ngIf="passwordValue">
            <p [class.valid]="checks.length">✔ Min 8 characters</p>
            <p [class.valid]="checks.upper">✔ One uppercase letter</p>
            <p [class.valid]="checks.lower">✔ One lowercase letter</p>
            <p [class.valid]="checks.number">✔ One number</p>
            <p [class.valid]="checks.special">✔ One special character</p>
          </div>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Confirm Password</mat-label>
            <input matInput [type]="hideConfirm ? 'password' : 'text'" formControlName="confirm" autocomplete="off" />
            <button mat-icon-button matSuffix type="button" (click)="hideConfirm = !hideConfirm"
              class="password-toggle">
              <mat-icon>
                {{ hideConfirm ? 'visibility_off' : 'visibility' }}
              </mat-icon>
            </button>

            <mat-error *ngIf="passwordForm.get('confirm')?.hasError('mismatch')">
              Passwords do not match
            </mat-error>
          </mat-form-field>

          <div class="forgotPassword_name">
            <button type="button" class="forgotPassword" (click)="goLogin()">
              Back to Login
            </button>
          </div>

          <!-- API MESSAGES -->
          <div class="api-error" *ngIf="apiError">{{ apiError }}</div>
          <div class="api-success" *ngIf="success">{{ success }}</div>

          <!-- ACTION BUTTON -->
          <div class="login-btn-wrapper">
            <button mat-raised-button class="secondary-login-in-button" type="submit" [disabled]="loading">
              {{ loading
              ? 'Processing...'
              : (firstTimeLogged ? 'Set Password' : 'Reset Password')
              }}
            </button>
          </div>

        </form>
      </mat-card>
    </div>
  </div>
</div>
